import React from "react";
import classNames from "classnames";
import logo from "../../../assets/img/logo.svg";
import styles from "./Logo.css";

export default function Logo(props) {
  return React.createElement(
    "svg",
    { viewBox: logo.viewBox, className: classNames(styles.root, props.isCompressed ? styles.compressed : {}) },
    React.createElement(
      "title",
      null,
      "Axios"
    ),
    React.createElement("use", { xlinkHref: "#" + logo.id })
  );
}


// WEBPACK FOOTER //
// ./src/components/Library/Logo/Logo.js